var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container_module"},[(_vm.loaderOn)?_c('div',{staticClass:"center-loader loader__assitance"},[_c('LoaderGeneric'),_c('div',{},[_vm._v("Cargando solicitud...")])],1):(_vm.BoostrapRequest)?_c('div',{staticClass:"container-slots container-base"},[_c('div',{on:{"click":_vm.getAssitanceFromUrl}},[_vm._v("click")])]):_c('div',{})])
}
var staticRenderFns = []

export { render, staticRenderFns }